module.exports = __webpack_public_path__ + "img/BR.23c03a16.svg";